export const TOKEN = 'TOKEN';
export const USER = 'USER';
